// extracted by mini-css-extract-plugin
export default {"nftHistoryRowContainer":"NftHistoryRow_nftHistoryRowContainer__f9w1Z","nftHistoryRowIcon":"NftHistoryRow_nftHistoryRowIcon__nwW8e"};